window.Products.Clothing.BodyconDress = function() {
};
window.Products.Clothing.BodyconDress.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.BodyconDress.id = 35;
window.Products.Clothing.BodyconDress.slug = 'bodycon-dress';
window.Products.Clothing.BodyconDress.has_3d = true;
window.Products.Clothing.BodyconDress.dpi = 150;

window.Products.Clothing.BodyconDress.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	modelViewer.object.position.y = 0.06;
	modelViewer.camera.position.z = 2.57;
	modelViewer.initalCameraPosition.z = -2.57;
};

window.Products.Clothing.BodyconDress.prototype.setThreeControls = function(controls) {
	controls.minDistance = 2.2;
	controls.maxDistance = 2.8;
};

window.Products.Clothing.BodyconDress.prototype.updateThreeTexture = function(modelViewer) {
    modelViewer.object.children[0].material.map = modelViewer.texture;
    modelViewer.object.children[1].material.map = modelViewer.texture;
    modelViewer.object.children[0].material.bumpScale = 0.0005;
    modelViewer.object.children[1].material.bumpScale = 0.0005;
};